
<template>
  <div class="index">
    <div class="indexTitle">
      <!-- <img class="logo" src="../assets/logo.png" alt=""> -->
        <img class="logo" :src="libraryInfo.logo" alt="">
      <span>欢迎走进{{libraryInfo.name}}</span>
    </div>
    <div class="aboutText">
      <div class="aboutTitleTs">{{article.titile}}</div>
      <div class="aboutWrap">
      <div class="aboutMain" >
        <div class="aboutP"  v-html="article.content"></div>
        <div class="aboutP"  v-html="article.content"></div>

      </div>
      </div>
    </div>
    <div class="bannerWrap">
      <div class="aboutTitle">形象展</div>
      <div class="banner">
        <img v-if="imageList.length>0" :src="imageList[index].mediaUrl" class="ban_img" alt="">
        <!-- <div class="banner_page">
            <img :class="{active:index==i}" v-for="(item,i) in imgArr" :src="item" alt="" v-on:click="click_banner(i)">
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import headers from './headers.vue'
  import service from '../service.js'
  import {getLibraryArticle, getLibraryImage} from '@/api/study';
  export default {
    components: {
      headers
    },
    data() {
      return {
        index: 0,
        imgArr: [
          require("../../static/banner01.png"),
          require("../../static/banner02.png"),
          require("../../static/banner03.png"),
        ],
        libraryId: null,
        article: {},
        filter: {
          // currentPage: 1,
          // pageSize: 10,
          libraryId: null,
        },
        imageList:[],
        textList:[],
        libraryInfo:{}
      }
    },
    created() {
      if (this.$route.query.libraryId) {
        this.libraryId = this.$route.query.libraryId;
        this.filter.libraryId = this.libraryId;
      }
      this.libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      this.getLibraryArticleInfo();
      this.getLibraryImageList();
      //启动自动轮播banner图...5秒一换（可根据需要调整banner轮播速度）
      window.setInterval(this.next, 5000); //1秒=1000*毫秒

    },
    mounted(){
      this.timers = setInterval(() => {
        this.getLibraryArticleInfo();
        this.getLibraryImageList();
      }, 5*60*1000);
    },
    methods: {
      next: function() {
        //点击切换下一图：
        if (this.index < this.imgArr.length - 1) {
          this.index++;
        } else {
          this.index = 0; //循环到第1图
        }
      },
      click_banner: function(i) {
        this.index = i; //点击跳转到指定的图
      },
      getdata() {
        this.$get(service.getAllLibraryName).then(res => {
          console.log('测试', res)
        })
      },
      getLibraryArticleInfo(){
        getLibraryArticle(this.libraryId).then(response=>{
          console.log('公告',response)
          this.article = response.data;
        })
      },
      getLibraryImageList(){
        getLibraryImage(this.filter).then(response=>{
          this.imageList = response.data;
          console.log(response.data)
        })
      }
    },
    destroyed() {
      clearInterval(this.timers);
    },
  }
</script>

<style scoped="scoped">
  .indexTitle{
    overflow: hidden;
    width: 100%;
    text-align: center;
    font-size: 72px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 140px;
  }

  .logo{
    float: left;
    width: 107px;
    height: 107px;
    margin-left: 38px;
    margin-top: 30px;
  }
  .aboutText {
    width: 32.3%;
    height: 880px;
    overflow: hidden;
    background-size: 100% 100%;
    position: relative;
    float: left;
    padding-bottom: 30px;
    margin-top: 12px;
    margin-left: 1%;
  }

  .aboutTitle {
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
  }
  .aboutTitleTs{
    margin-top: 12px;
    margin-left: 20px;
    text-align: left;
    font-size: 42px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
  }
  .aboutWrap{
    width: 89.5%;
    height: 850px;
    overflow: hidden;
    margin: 27px auto 0;
  }
  .aboutMain {
    width: 100%;
    text-align: left;
    animation: seamless-scrolling 90s linear infinite;
  }
  .aboutP{
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 44px;

  }
  @keyframes seamless-scrolling {
    0% {
      transform: translateY(0px);
    }
    100% {
      transform: translateY(-51%);
    }
  }
  .bannerWrap {
    width: 63.64%;
    height: 910px;
    float: left;
    background: url(../../static/bannerBg.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 12px;
    margin-left: 1%;

  }

  .banner {
    width: 95%;
    margin: 28px auto;
    height: 730px;
    position: relative;
  }

  .ban_img {
    width: 100%;
    height: 100%;
  }

  .banner_page {
    width: 268px;
    overflow-x: hidden;
    overflow-y: scroll;
    position: absolute;
    top: 0;
    right: 10px;
    display: -webkit-box;
    -webkit-overflow-scrolling: touch;

  }

  .banner_page::-webkit-scrollbar {
    width: 0px;
  }

  .banner_page::-webkit-scrollbar-track {
    background-color: none;
  }

  .banner_page::-webkit-scrollbar-thumb {
    background-color: none;
  }

  .banner_page::-webkit-scrollbar-thumb:hover {
    background-color: none;
  }

  .banner_page::-webkit-scrollbar-thumb:active {
    background-color: none;
  }

  .banner_page img {
    width: 100%;
    height: 206px;
    margin-top: 10px;
  }

  .active {
    border: 1px solid coral;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/components/index.vue